/**
 * Generated by orval from the Collective Payroll API contract. Do not edit manually.
 */
import { W9StatusEnum } from './w9StatusEnum';

export const TeamMemberW9Status = { ...W9StatusEnum } as const;
